import { inputKeyMappingService } from "./InputKeyMappingService";
const NUM_GAMEPADS = 4;
const keyNameToGamepadButtonIndex = new Map();
keyNameToGamepadButtonIndex.set("GamepadDpadDown", 15);
keyNameToGamepadButtonIndex.set("GamepadDpadLeft", 13);
keyNameToGamepadButtonIndex.set("GamepadDpadRight", 14);
keyNameToGamepadButtonIndex.set("GamepadDpadUp", 12);
keyNameToGamepadButtonIndex.set("GamepadFaceButtonBottom", 0);
keyNameToGamepadButtonIndex.set("GamepadFaceButtonLeft", 2);
keyNameToGamepadButtonIndex.set("GamepadFaceButtonRight", 1);
keyNameToGamepadButtonIndex.set("GamepadFaceButtonUp", 3);
keyNameToGamepadButtonIndex.set("GamepadLeftShoulder", 4);
keyNameToGamepadButtonIndex.set("GamepadLeftTigger", 6);
keyNameToGamepadButtonIndex.set("GamepadRightShoulder", 5);
keyNameToGamepadButtonIndex.set("GamepadRightTrigger", 7);
keyNameToGamepadButtonIndex.set("GamepadLeft2D", 8);
keyNameToGamepadButtonIndex.set("GamepadRight2D", 9);
keyNameToGamepadButtonIndex.set("GamepadLeftThumbstick", 10);
keyNameToGamepadButtonIndex.set("GamepadRightThumbstick", 11);
const keyNameToGamepadAxisIndex = new Map();
keyNameToGamepadAxisIndex.set("GamepadLeftX", 0);
keyNameToGamepadAxisIndex.set("GamepadLeftY", 1);
keyNameToGamepadAxisIndex.set("GamepadRightX", 2);
keyNameToGamepadAxisIndex.set("GamepadRightY", 3);
export class GamepadsDevice {
    constructor() {
        this.gamepads = [];
        this.inputsActive = true;
        for (let i = 0; i < NUM_GAMEPADS; ++i) {
            this.gamepads.push({
                index: i
            });
        }
    }
    poll() {
        // const gamepads: Array<Gamepad | null> = "getGamepads" in navigator ? navigator.getGamepads() : (navigator as any).webkitGetGamepads()
        const gamepads = 'getGamepads' in navigator
            ? navigator.getGamepads()
            : navigator.webkitGetGamepads();
        for (let gamepadIndex = 0; gamepadIndex < this.gamepads.length; gamepadIndex++) {
            const gamepad = gamepads[gamepadIndex];
            const gamepadData = this.gamepads[gamepadIndex];
            if (!gamepad) {
                if (gamepadData.gamepad) {
                    console.debug(`[inputs] Gamepad "${gamepadData.gamepad.id}" disconnected`);
                    gamepadData.gamepad = undefined;
                }
                continue;
            }
            if (!gamepad.connected) {
                if (gamepadData.gamepad) {
                    console.debug(`[inputs] Gamepad "${gamepadData.gamepad.id}" disconnected`);
                    gamepadData.gamepad = undefined;
                }
                continue;
            }
            if (!gamepadData.gamepad) {
                console.debug(`[inputs] Gamepad "${gamepad.id}" connected`);
            }
            gamepadData.gamepad = gamepad;
            gamepadIndex++;
        }
    }
    getAxisValue(gamepadIndex, keyName, config, axisIndex, buttonIndex) {
        if (!this.inputsActive)
            return 0;
        const data = this.gamepads[gamepadIndex];
        if (!data)
            return 0;
        if (!data.gamepad)
            return 0;
        const keyDetails = inputKeyMappingService.getKeyDetails(keyName);
        if (!keyDetails)
            return 0;
        let axisValue = 0;
        if (axisIndex === undefined) {
            axisIndex = keyNameToGamepadAxisIndex.get(keyName);
        }
        if (axisIndex !== undefined) {
            let value = data.gamepad.axes[axisIndex];
            if (value !== undefined) {
                if (config && Math.abs(value) < config.deadZone)
                    value = 0;
                axisValue += value;
            }
        }
        if (buttonIndex === undefined) {
            buttonIndex = keyNameToGamepadButtonIndex.get(keyName);
        }
        if (buttonIndex !== undefined) {
            const button = data.gamepad.buttons[buttonIndex];
            if (button) {
                axisValue += button.value;
            }
        }
        return axisValue;
    }
}
